module.exports = __webpack_public_path__ + "img/events.2e4d4525.png";